import React from "react";
import "./home-styles.css";
import "../theme/app-styles.css";

import {
  IonContent,
  IonPage,
} from "@ionic/react";

const Home: React.FC = () => {
  
 
  return (
    <IonPage>
      <IonContent>
        <section className="header">
          <div className="logo-box">
            <img
              src={require("../img/logo-mods.png")}
              alt="Logo"
              className="logo"
            />
          </div>

          <div className="text-box">
            <h1 className="heading-primary">
              <span className="heading-primary-main">Nampa OCIA</span>

              <span className="heading-primary-sub heading-primary-sub-line2">
                Encountering Jesus Christ
              </span>
            </h1>
          </div>
          <div className="reg-button-container">
            <div className="closed-note">
              <p style={{padding: "10px", textAlign: "center"}}> <strong>Registration for Next Year Opens on July 19th.</strong><br/></p>
            </div>
          </div>
           <div className="button-container">
            
            <div>
              <a
                href="/sponsors"
                className="btn btn-white btn-animated button"
              >
                Sponsor Form
              </a>
            </div>
         
            <div>
              <a
                href="/uploads"
                className="btn btn-white btn-animated button"
              >
                Document Uploads
              </a>
            </div>
          </div>
        </section>
      </IonContent>
    </IonPage>
  );
};

export default Home;
